import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = (props) => {
  const type = props && props.type;
  let resize = (type && type === 'banner')
    ? '14px'
    : '12px';

  resize = (type && type === 'tooltip')
  ? '10px'
  : '12px';

  const viewBox = (type && type === 'banner')
    ? '0 0 21 21'
    : '0 0 12 12';

  return (
     <svg role="img" className="close-icon"  width={resize} height={resize} viewBox={viewBox} version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Close Icon</title>
      <g fill="currentColor" stroke="none" strokeWidth="1" fillRule="evenodd" strokeLinecap="square">
        { type === 'banner' ?
          <g>
            <path stroke="currentColor" strokeLinecap="null" strokeLinejoin="null" strokeWidth="2" fill="none" d="M1 .938l19 19.124" />
            <path d="M1.257 20.475l-.707-.708L19.884.433l.707.707L1.257 20.475z" />
            <path stroke="currentColor" strokeLinecap="null" strokeLinejoin="null" strokeWidth="2" fill="none" d="M1.018 20.268L20.294.67" />
          </g>
          :
          <g id="CloseIcon" transform="translate(-1381.000000, -2.000000)" stroke="currentColor">
            <path d="M1381.92191,2.79863811 L1392.53088,13.4028723" />
            <path d="M1381.84551,13.4521146 L1392.44975,2.84314588" />
          </g>
        }
      </g>
    </svg> 

  );
};

CloseIcon.propTypes = {
  type: PropTypes.string,
  icon:PropTypes.string,
};

CloseIcon.defaultProps = {
  type: '',
  icon:'',
};

export default CloseIcon;
